module.exports = __webpack_public_path__ + "media/images/icon/meeting-64f9f84ae3bfef1583f3993b842a7074.svg";